import { useRef } from "react";
import SignatureCanvas from "./SignatureCanvas";
import {
    clearSignature,
    getSignatureData,
} from "./signature.helpers";

export default function SignaturePad({
    value,
    onChange,
    required = false,
}) {
    const signatureRef = useRef();

    const handleSave = () => {
        const data = getSignatureData(signatureRef);

        if (!data) {
            if (required) {
                alert("Please provide your signature.");
            }
            return;
        }

        onChange(data);
    };

    return (
        <div className="space-y-4">

            <SignatureCanvas ref={signatureRef} />

            <div className="flex gap-3">

                <button
                    type="button"
                    onClick={() => clearSignature(signatureRef)}
                    className="px-4 py-2 rounded border"
                >
                    Clear
                </button>

                <button
                    type="button"
                    onClick={handleSave}
                    className="px-4 py-2 rounded bg-blue-600 text-white"
                >
                    Save Signature
                </button>

            </div>

        </div>
    );
}